import React from "react";
import { AddOrEditMachineProxyPage } from "./AddOrEditMachineProxyPage";
interface AddMachineProxyPageProps {
    spaceId: string;
}
export function AddMachineProxyPage({ spaceId }: AddMachineProxyPageProps) {
    return <AddOrEditMachineProxyPage create spaceId={spaceId}/>;
}
